export const emptyAreeVerdi = {
    "type": "FeatureCollection",
    "name": "20221025-Bergamo_areeverdi-sintesi_GreenSpaces_S3",
    "crs": {
      "type": "name",
      "properties": { "name": "urn:ogc:def:crs:OGC:1.3:CRS84" },
    },
    "features": [],
  };